import {
  Box,
  Card,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { TenantsFormControl } from '@/components/form/TenantsFormControl.tsx';
import { useGetPickem } from '@/api/pickems/getPickem.ts';
import { PickemStatusEnum, PickemTypeEnum } from '@/enums/Pickem.enums.ts';
import { AnyFieldApi } from '@tanstack/react-form';
import { LocalizedDateTimePicker } from 'src/components/form/LocalizedDateTimePicker';

interface EditGeneralSettingsProps {
  form: any;
}

export const EditGeneralSettings = ({ form }: EditGeneralSettingsProps) => {
  const { isLoading: getPickemIsLoading } = useGetPickem(form.pickemId);

  if (getPickemIsLoading) {
    return (
      <Card sx={{ padding: 4 }}>
        <Box
          sx={{ display: 'flex', justifyContent: 'center' }}
          style={{ padding: 20 }}
        >
          <CircularProgress />
        </Box>
      </Card>
    );
  }

  return (
    <Card sx={{ padding: 4, marginBottom: 4 }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <form.Field
            name='status'
            children={({ state, handleChange }: AnyFieldApi) => (
              <FormControl fullWidth>
                <InputLabel id='status-label'>Status</InputLabel>
                <Select
                  labelId='status-label'
                  value={state.value}
                  label='Status'
                  onChange={(e) => handleChange(e.target.value)}
                >
                  <MenuItem value={PickemStatusEnum.DRAFT}>DRAFT</MenuItem>
                  <MenuItem value={PickemStatusEnum.UPCOMING}>
                    UPCOMING
                  </MenuItem>
                  <MenuItem value={PickemStatusEnum.IN_PLAY}>IN_PLAY</MenuItem>
                  <MenuItem value={PickemStatusEnum.COMPLETE}>
                    COMPLETE
                  </MenuItem>
                </Select>
              </FormControl>
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <form.Field
            name='start'
            children={({ state, handleChange }: AnyFieldApi) => (
              <LocalizedDateTimePicker
                label='Start'
                value={state.value}
                onChange={(value: string) => handleChange(value)}
              />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <form.Field
            name='tenants_prefixes'
            children={({ state, handleChange }: AnyFieldApi) => (
              <TenantsFormControl
                value={state.value}
                onChange={(value) =>
                  handleChange(
                    typeof value === 'string' ? value.split(',') : value
                  )
                }
              />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <form.Field
            name='pickem_type'
            children={({ state, handleChange, handleBlur }: AnyFieldApi) => {
              return (
                <FormControl fullWidth>
                  <InputLabel id='pickem_type-label'>Pickem Type</InputLabel>
                  <Select
                    labelId='pickem_type-label'
                    value={state.value}
                    label='Status'
                    onChange={(e) => {
                      handleChange(e.target.value);
                    }}
                    onBlur={handleBlur}
                    defaultValue={PickemTypeEnum.PUBLIC}
                  >
                    <MenuItem value={PickemTypeEnum.PUBLIC}>Public</MenuItem>
                    <MenuItem value={PickemTypeEnum.PRIVATE}>Private</MenuItem>
                  </Select>
                </FormControl>
              );
            }}
          />
        </Grid>
      </Grid>
    </Card>
  );
};
